import React from "react";
import classes from "./NumberText.scss";

const NumberText = props => {
  const { columnData } = props;
  return <div className={classes.number}>{columnData}</div>;
};

export default NumberText;
